var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "#00D0C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.3 47.93C205.3 49.01 205 49.95 204.4 50.75C203.82 51.55 202.99 52.18 201.91 52.64C200.83 53.08 199.51 53.3 197.95 53.3C196.61 53.3 195.29 53.12 193.99 52.76C192.71 52.4 191.68 51.93 190.9 51.35L192.31 48.41C193.03 48.95 193.91 49.38 194.95 49.7C195.99 50.02 197.05 50.18 198.13 50.18C199.41 50.18 200.3 49.99 200.8 49.61C201.3 49.23 201.55 48.78 201.55 48.26C201.55 47.78 201.36 47.4 200.98 47.12C200.62 46.84 200.13 46.62 199.51 46.46C198.91 46.28 198.25 46.12 197.53 45.98C196.81 45.82 196.09 45.64 195.37 45.44C194.65 45.24 193.99 44.96 193.39 44.6C192.79 44.24 192.3 43.76 191.92 43.16C191.56 42.56 191.38 41.8 191.38 40.88C191.38 39.82 191.68 38.89 192.28 38.09C192.88 37.29 193.72 36.67 194.8 36.23C195.9 35.79 197.19 35.57 198.67 35.57C199.73 35.57 200.79 35.69 201.85 35.93C202.93 36.15 203.87 36.52 204.67 37.04L203.38 39.98C202.62 39.48 201.82 39.14 200.98 38.96C200.16 38.76 199.35 38.66 198.55 38.66C197.35 38.66 196.48 38.85 195.94 39.23C195.42 39.61 195.16 40.09 195.16 40.67C195.16 41.15 195.34 41.53 195.7 41.81C196.08 42.09 196.57 42.32 197.17 42.5C197.77 42.66 198.43 42.81 199.15 42.95C199.89 43.09 200.61 43.27 201.31 43.49C202.03 43.69 202.69 43.97 203.29 44.33C203.91 44.67 204.4 45.13 204.76 45.71C205.12 46.29 205.3 47.03 205.3 47.93ZM214.45 53.3C212.65 53.3 211.04 52.92 209.62 52.16C208.2 51.38 207.08 50.32 206.26 48.98C205.44 47.64 205.03 46.12 205.03 44.42C205.03 42.72 205.44 41.21 206.26 39.89C207.08 38.55 208.2 37.5 209.62 36.74C211.04 35.96 212.65 35.57 214.45 35.57C216.01 35.57 217.37 35.81 218.53 36.29C219.71 36.75 220.71 37.48 221.53 38.48L219.07 40.82C218.47 40.12 217.79 39.61 217.03 39.29C216.27 38.95 215.45 38.78 214.57 38.78C213.47 38.78 212.48 39.02 211.6 39.5C210.74 39.98 210.06 40.65 209.56 41.51C209.08 42.35 208.84 43.32 208.84 44.42C208.84 45.52 209.08 46.5 209.56 47.36C210.06 48.22 210.74 48.89 211.6 49.37C212.48 49.85 213.47 50.09 214.57 50.09C215.45 50.09 216.27 49.92 217.03 49.58C217.79 49.24 218.47 48.72 219.07 48.02L221.53 50.39C220.71 51.37 219.71 52.1 218.53 52.58C217.35 53.06 215.99 53.3 214.45 53.3ZM222.556 53V35.84H226.336V53H222.556ZM232.42 42.83H241.12V45.77H232.42V42.83ZM232.93 49.97H242.47V53H229.15V35.84H242.14V38.9H232.93V49.97ZM243.977 53V35.84H247.097L257.447 48.38H256.037V35.84H259.787V53H256.667L246.317 40.46H247.757V53H243.977ZM270.622 53.3C268.822 53.3 267.212 52.92 265.792 52.16C264.372 51.38 263.252 50.32 262.432 48.98C261.612 47.64 261.202 46.12 261.202 44.42C261.202 42.72 261.612 41.21 262.432 39.89C263.252 38.55 264.372 37.5 265.792 36.74C267.212 35.96 268.822 35.57 270.622 35.57C272.182 35.57 273.542 35.81 274.702 36.29C275.882 36.75 276.882 37.48 277.702 38.48L275.242 40.82C274.642 40.12 273.962 39.61 273.202 39.29C272.442 38.95 271.622 38.78 270.742 38.78C269.642 38.78 268.652 39.02 267.772 39.5C266.912 39.98 266.232 40.65 265.732 41.51C265.252 42.35 265.012 43.32 265.012 44.42C265.012 45.52 265.252 46.5 265.732 47.36C266.232 48.22 266.912 48.89 267.772 49.37C268.652 49.85 269.642 50.09 270.742 50.09C271.622 50.09 272.442 49.92 273.202 49.58C273.962 49.24 274.642 48.72 275.242 48.02L277.702 50.39C276.882 51.37 275.882 52.1 274.702 52.58C273.522 53.06 272.162 53.3 270.622 53.3ZM281.998 42.83H290.698V45.77H281.998V42.83ZM282.508 49.97H292.048V53H278.728V35.84H291.718V38.9H282.508V49.97ZM296.685 53L304.485 35.84H308.235L316.005 53H312.255L305.715 37.76H306.975L300.375 53H296.685ZM300.555 49.28L301.575 46.4H310.515L311.535 49.28H300.555ZM316.059 53V35.84H319.179L329.529 48.38H328.119V35.84H331.869V53H328.749L318.399 40.46H319.839V53H316.059ZM334.694 53V35.84H342.464C344.424 35.84 346.114 36.19 347.534 36.89C348.974 37.59 350.084 38.59 350.864 39.89C351.664 41.17 352.064 42.68 352.064 44.42C352.064 46.18 351.664 47.7 350.864 48.98C350.084 50.26 348.974 51.25 347.534 51.95C346.114 52.65 344.424 53 342.464 53H334.694ZM338.474 49.94H342.344C343.564 49.94 344.614 49.72 345.494 49.28C346.374 48.84 347.054 48.21 347.534 47.39C348.014 46.57 348.254 45.58 348.254 44.42C348.254 43.26 348.014 42.27 347.534 41.45C347.054 40.63 346.374 40.01 345.494 39.59C344.614 39.15 343.564 38.93 342.344 38.93H338.474V49.94ZM359.367 53V35.84H363.147V53H359.367ZM365.961 53V35.84H369.081L379.431 48.38H378.021V35.84H381.771V53H378.651L368.301 40.46H369.741V53H365.961ZM384.596 53V35.84H387.716L398.066 48.38H396.656V35.84H400.406V53H397.286L386.936 40.46H388.376V53H384.596ZM411.301 53.3C409.481 53.3 407.851 52.92 406.411 52.16C404.991 51.38 403.871 50.32 403.051 48.98C402.231 47.64 401.821 46.12 401.821 44.42C401.821 42.72 402.231 41.21 403.051 39.89C403.871 38.55 404.991 37.5 406.411 36.74C407.851 35.96 409.471 35.57 411.271 35.57C413.091 35.57 414.711 35.96 416.131 36.74C417.571 37.5 418.701 38.55 419.521 39.89C420.341 41.21 420.751 42.72 420.751 44.42C420.751 46.12 420.341 47.64 419.521 48.98C418.701 50.32 417.571 51.38 416.131 52.16C414.711 52.92 413.101 53.3 411.301 53.3ZM411.271 50.09C412.371 50.09 413.341 49.85 414.181 49.37C415.041 48.87 415.711 48.19 416.191 47.33C416.671 46.47 416.911 45.5 416.911 44.42C416.911 43.32 416.661 42.35 416.161 41.51C415.681 40.65 415.021 39.98 414.181 39.5C413.341 39.02 412.381 38.78 411.301 38.78C410.221 38.78 409.251 39.02 408.391 39.5C407.531 39.98 406.851 40.65 406.351 41.51C405.871 42.35 405.631 43.32 405.631 44.42C405.631 45.5 405.871 46.47 406.351 47.33C406.851 48.19 407.531 48.87 408.391 49.37C409.251 49.85 410.211 50.09 411.271 50.09ZM426.495 53L418.935 35.84H422.985L429.585 51.23H427.275L433.965 35.84H437.775L430.245 53H426.495ZM434.167 53L441.967 35.84H445.717L453.487 53H449.737L443.197 37.76H444.457L437.857 53H434.167ZM438.037 49.28L439.057 46.4H447.997L449.017 49.28H438.037ZM455.636 53V38.93H449.996V35.84H465.056V38.93H459.416V53H455.636ZM465.379 53V35.84H469.159V53H465.379ZM480.043 53.3C478.223 53.3 476.593 52.92 475.153 52.16C473.733 51.38 472.613 50.32 471.793 48.98C470.973 47.64 470.563 46.12 470.563 44.42C470.563 42.72 470.973 41.21 471.793 39.89C472.613 38.55 473.733 37.5 475.153 36.74C476.593 35.96 478.213 35.57 480.013 35.57C481.833 35.57 483.453 35.96 484.873 36.74C486.313 37.5 487.443 38.55 488.263 39.89C489.083 41.21 489.493 42.72 489.493 44.42C489.493 46.12 489.083 47.64 488.263 48.98C487.443 50.32 486.313 51.38 484.873 52.16C483.453 52.92 481.843 53.3 480.043 53.3ZM480.013 50.09C481.113 50.09 482.083 49.85 482.923 49.37C483.783 48.87 484.453 48.19 484.933 47.33C485.413 46.47 485.653 45.5 485.653 44.42C485.653 43.32 485.403 42.35 484.903 41.51C484.423 40.65 483.763 39.98 482.923 39.5C482.083 39.02 481.123 38.78 480.043 38.78C478.963 38.78 477.993 39.02 477.133 39.5C476.273 39.98 475.593 40.65 475.093 41.51C474.613 42.35 474.373 43.32 474.373 44.42C474.373 45.5 474.613 46.47 475.093 47.33C475.593 48.19 476.273 48.87 477.133 49.37C477.993 49.85 478.953 50.09 480.013 50.09ZM490.872 53V35.84H493.992L504.342 48.38H502.932V35.84H506.682V53H503.562L493.212 40.46H494.652V53H490.872Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.2e9afe6478e36e590944f0c7cbdc276b.svg";
export { ForwardRef as ReactComponent };